import { TreesloGridModel } from "../components/treeslo-grid";

/** Common ViewStateCacheService field for persisted grid column order. */
export interface GridColumnOrderViewCachedState {
  columnOrder?: string[];
}

export function withReorderableGridColumns<ItemModel>(
  config: TreesloGridModel<ItemModel>,
  columnOrder?: string[],
): TreesloGridModel<ItemModel> {
  return {
    ...config,
    reorderableColumns: true,
    columnOrder,
  };
}

export function applyGridColumnOrderChange<ItemModel>(
  columnOrder: string[],
  gridConfig: TreesloGridModel<ItemModel> | null,
): TreesloGridModel<ItemModel> | null {
  if (!gridConfig) {
    return null;
  }

  return {
    ...gridConfig,
    columnOrder,
  };
}
